export default __webpack_public_path__ + "static/Blog (2)-5c364c58fcd3e1dd9fc50586dad834e1.jpg";